import React from "react";
import { useTranslation } from "react-i18next";
import UpgradeComponents from "../../components/upgrade/UpgradeComponents";
import { ApiHook } from "../../hooks/apiHook";
import UpgradePaymentModal from "../../components/upgrade/UpgradePaymentModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Upgrade = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [selectedUpgradePlan, setSelectedUpgradePlan] = useState();
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const handleUpgradeClick = (plan) => {
    setShow(true);
    console.log({ plan });
    setSelectedUpgradePlan(plan);
  };
  const productsList = ApiHook.CallGetUpgradeProducts();
  const currentProduct =
    productsList &&
    productsList.upgradeData?.find((item) => item.upgradable === 1);
  const approvalPendingStatus = productsList?.approvalPendingStatus;

  return (
    <>
      <div className="page_head_top">{t("upgrade")}</div>
      <UpgradeComponents
        data={productsList && productsList.upgradeData}
        handleUpgradeClick={handleUpgradeClick}
        currency={userSelectedCurrency}
        conversionFactor={conversionFactor}
      />
      <UpgradePaymentModal
        show={show}
        setShow={setShow}
        currentProduct={currentProduct}
        data={selectedUpgradePlan}
        currency={userSelectedCurrency}
        conversionFactor={conversionFactor}
        approvalPendingStatus={approvalPendingStatus}
      />
    </>
  );
};

export default Upgrade;
